export default function ExperienceEducation() {
    return (
        <div className="education_experience" >
            <h1 className="text-center"><i class="uil uil-briefcase-alt qualification__icon"></i>Experience</h1>
            <br />
            <ul data-aos="fade-up" data-aos-duration="2000">
            <li>
                    <h5>Software Engineer - II  </h5>
                    <div className="row">
                        <h6 className="col-8">JP Morgan Chase & Co.</h6>
                        <h6 className="col-4"> Feb '25 - Present</h6>
                    </div>
             <br/>
            </li>
            <li>
                    <h5>Software Engineer - I  </h5>
                    <div className="row">
                        <h6 className="col-8">JP Morgan Chase & Co.</h6>
                        <h6 className="col-4"> March '23 - Jan '25</h6>
                    </div>
            </li>
                <br/>
                <li>
                    <h5>Software Development Engineer - I  </h5>
                    <div className="row">
                        <h6 className="col-8">Amazon, India</h6>
                        <h6 className="col-4">Aug '22 - March '23</h6>
                    </div>
                </li>
                <br/>
                <li>
                    <h5>Associate Developer and Intern</h5>
                    <div className="row">
                        <h6 className="col-8">SAP Labs, India</h6>
                        <h6 className="col-4">Jan '22 - Aug '22</h6>
                    </div>
                </li>
                <br/>
                <li>
                    <h5>Intern </h5>
                    <div className="row">
                        <h6 className="col-8">Fidelity Investments</h6>
                        <h6 className="col-4">Jun '21 - Aug '21</h6>
                    </div>
                </li>
            </ul>
        </div>
    )
}
